import { Component, OnInit, Input } from '@angular/core';

import { DomService } from '../../service';
import { NgIf } from '@angular/common';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'pod-options-component',
    templateUrl: './pod-options.component.html',
    styleUrls: ['./pod-options.component.scss'],
    imports: [NgIf]
})
export class PodOptionsComponent implements OnInit {

  @Input() cursorPosition: number;

  constructor(private domService: DomService) { }

  ngOnInit() {
    this.cursorPosition = -1;
    // Was hoping to get this to work before doing one. By appending the popup to the body it should make it visible on the pod maintenance page.
    // this.domService.appendComponentToBody(this);
  }

  showToolTip(minPos: number, maxPos: number) {
    if (this.cursorPosition >= minPos && this.cursorPosition <= maxPos) {
      return true;
    }
    return false;
  }
}
